var _defs, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNsaqIconFav(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.37,3.75c-.43-.43-.93-.76-1.49-.99-.56-.23-1.15-.35-1.75-.35s-1.2.12-1.75.35c-.56.23-1.06.57-1.49.99l-.88.88-.88-.88c-.86-.86-2.03-1.34-3.24-1.34s-2.38.48-3.24,1.34c-.86.86-1.34,2.03-1.34,3.24s.48,2.38,1.34,3.24l.88.88,6.48,6.48,6.48-6.48.88-.88c.43-.43.76-.93.99-1.49.23-.56.35-1.15.35-1.75s-.12-1.2-.35-1.75c-.23-.56-.57-1.06-.99-1.49h0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsaqIconFav);
export default __webpack_public_path__ + "static/media/nsaq-icon-fav.5d112f396ac1c88b722795b54b6986d9.svg";
export { ForwardRef as ReactComponent };